import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import useToast from "../../../hooks/userToast";
import { Eye, EyeOff } from "feather-icons-react/build/IconComponents";

// Define Yup schema
const schema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[a-zA-Z]/, "Password must contain at least one letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character"
    )
    .required("New password is required"),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match") // Corrected reference here
    .required("Please confirm your new password"),
});

const ChangePassword = ({ id, handleCancel }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const { toastSuccess, toastError } = useToast();
  useEffect(() => {
    reset();
  }, [id]);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordVisible1, setPasswordVisible1] = useState(false);
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  const togglePasswordVisibility1 = () => {
    setPasswordVisible1(!passwordVisible1);
  };
  const handlePost = async (values) => {
    const body = {
      newPassword: values.newPassword,
    };
    try {
      await apiClient.patch(`users/${id}/change-password`, body);
      toastSuccess("Password Changed Successfully!");
      reset();
      handleCancel();
    } catch (err) {
      toastError(err?.response?.data?.error);
    }
  };

  return (
    <div className="new_custom_css">
      <div className="content">
        <div className="main-wrapper login-body">
          <div className="container-fluid px-0">
            <div className="row">
              <div className="col-lg-12">
                <div className="login-wrapper">
                  <div className="loginbox">
                    <div className="form_label">
                      <div className="login-right-wrap">
                        <form
                          onSubmit={handleSubmit(handlePost)}
                          className="row change_userpassword"
                        >
                          <div className="form-group d-flex flex-column text_area position-relative">
                            <label>
                              New Password{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              type={passwordVisible ? "text" : "password"}
                              className="form-control pass-input"
                              {...register("newPassword")}
                            />
                            <span
                              onClick={togglePasswordVisibility}
                              style={{
                                position: "absolute",
                                top: "34px",
                                right: "25px",
                              }}
                            >
                              {passwordVisible ? (
                                <EyeOff className="react-feather-custom" />
                              ) : (
                                <Eye className="react-feather-custom" />
                              )}
                            </span>
                            {errors.newPassword && (
                              <small className="error-message login-danger ">
                                {errors.newPassword.message}
                              </small>
                            )}
                          </div>
                          <div className="form-group d-flex flex-column text_area position-relative">
                            <div className="form-group">
                              <label>
                                Confirm Password{" "}
                                <span className="login-danger">*</span>
                              </label>
                              <input
                                type={passwordVisible1 ? "text" : "password"}
                                className="form-control pass-input"
                                {...register("confirmPassword")}
                              />
                              <span
                                style={{
                                  position: "absolute",
                                  top: "34px",
                                  right: "25px",
                                }}
                                onClick={togglePasswordVisibility1}
                              >
                                {passwordVisible1 ? (
                                  <EyeOff className="react-feather-custom" />
                                ) : (
                                  <Eye className="react-feather-custom" />
                                )}
                              </span>
                              {errors.confirmPassword && (
                                <small className="error-message login-danger">
                                  {errors.confirmPassword.message}
                                </small>
                              )}
                            </div>
                          </div>

                          <div className="form-group login-btn d-flex gap-5 justify-content-center new_type_register">
                            <button
                              className="btn btn-primary btn-block w-25"
                              type="submit"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ChangePassword.propTypes = {
  id: PropTypes.string,
  handleCancel: PropTypes.func,
};

export default ChangePassword;
